import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'antd';
import styles from './index.module.less';
import { IListItem, IResultViewType } from '@pro/activity/testerClub/interface';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import { IUseEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import { RouteEnum } from 'pro/config/routers';
import { useStore, useStoreState } from 'base/store'
import { useRouter } from 'next/router';
import { generatePath } from 'ava-util/dist/request';
import HelpPopup, { IModalRef } from '@base/lib/HelpPopup';
import { useTrans } from 'base/utils/i18n'
import ResultsModal from '@pro/activity/testerClub/ResultsModal'
import ApplySuccessPopup from '@pro/activity/testerClub/Products/ApplySuccessPopup'
import { isPhone } from 'base/utils/client';
import { nativeLogin } from 'base/utils/app';

type IProps = {
    className?: string;
    earlyAccess: IUseEarlyAccess;
    product: IListItem
}

const BtnProps: any = {
    block: isPhone,
    size: isPhone ? 'middle' : 'large'
}


const ViewReviewBtn = ({
                           onClick
                       }) => {
    const { t } = useTrans();

    return (
        <Button
            {...BtnProps}
            block
            className={styles['view-btn']}
            type={"primary"}
            onClick={onClick}
        >{t('web_diy_view_reviews')}</Button>
    )
}


const OptionsButton: React.FC<IProps> = (props) => {
    const { className, product, earlyAccess } = props
    const {
        userStore
    } = useStore();
    const router = useRouter();
    const { query } = router;
    const { activityId: queryActivityId = '' } = query;

    const popupRef = useRef<IModalRef>(null);
    const { t } = useTrans();

    const [loading, setLoading] = useState<boolean>(false);
    const [resultsModalProps, setResultsModalProps] = useState<{
        open: boolean;
        viewType?: IResultViewType;
    }>();
    const [applyVisible, setApplyVisible] = useState<boolean>(false);

    const { ua: { isApp } } = useStoreState('rootStore');

    const { onSubmitApply } = earlyAccess
    const {
        userParticipated,
    } = product

    const onSubmit = async () => {
        setLoading(true)
        await onSubmitApply?.(product)
        popupRef.current?.close()
        setLoading(false)
        setApplyVisible(true)
    }

    const seeResultsPage = (type: IResultViewType = 'result') => {
        if (isPhone) {
            const path = generatePath(
                RouteEnum.TesterClubResults,
                { activityId: product.activityGid },
                { viewType: type }
            )
            router.push(path)

        } else {
            setResultsModalProps({
                open: true,
                viewType: type
            })
        }
    }

    const goLogin = () => {
        // pc 未登录
        if (!userStore.checkAuth() && (!isPhone || isApp)) {
            if (isApp) {
                nativeLogin();
            } else {
                router.push(generatePath(RouteEnum.LOGIN, { redirect: router.asPath }))
            }
            return
        } else {
            // pc已登录
            // m 未登录、已登录都跳转下一个页面
            seeResultsPage('result')
        }
    }

    const onCloseResultModal = () => {
        setResultsModalProps({
            open: false,
        })
    }

    const currentTime = Math.floor(Date.now() / 1000);

    const isNotStart = +(product.startTime || 0) > currentTime
    const isEnd = product.end || +(product.endTime || 0) < currentTime
    const hasReviews = product.reviewHasReview

    useEffect(() => {
        if (!!queryActivityId && !!product) {
            if (queryActivityId == product.activityGid) {
                // 匹配直接查看活动结果
                seeResultsPage('result')
            }
        }
    }, [queryActivityId])

    // 未开始
    if (isNotStart) {
        return null
    }

    // 未登录
    if (!userStore.checkAuth()) {
        return (
            <>
                {hasReviews && (
                    <ViewReviewBtn
                        onClick={goLogin}
                    />
                )}

                <Button
                    {...BtnProps}
                    type={isEnd ? (isPhone ? "text" : "ghost") : "primary"}
                    block
                    onClick={goLogin}
                    className={cn(
                        className,
                        styles[isEnd ? 'end-btn' : 'btn'],
                        hasReviews && styles['btn-2']
                    )}
                >
                    {t(isEnd ? 'web_common_view_results' : 'web_common_apply')}
                    {isEnd ? ' >' : ''}
                </Button>
            </>
        )
    }

    // 商品活动结束
    if (isEnd) {
        return (
            <>
                {!isPhone && (
                    <ResultsModal
                        {...resultsModalProps}
                        product={product}
                        onClose={onCloseResultModal}
                    />
                )}

                {hasReviews && (
                    <ViewReviewBtn
                        onClick={() => seeResultsPage('review')}
                    />
                )}

                <Button
                    {...BtnProps}
                    block
                    type={isPhone ? "text" : "ghost"}
                    onClick={() => seeResultsPage('result')}
                    className={cn(
                        className,
                        styles['end-btn'],
                        hasReviews && styles['btn-2']
                    )}
                >{t('web_common_view_results')} {' >'} </Button>
            </>
        )
    }

    // 已参加
    if (userParticipated) {
        return (
            <>
                <ApplySuccessPopup
                    product={product}
                    earlyAccess={earlyAccess}
                    visible={applyVisible}
                    setVisible={setApplyVisible}
                />
                <Button
                    {...BtnProps}
                    block
                    disabled
                    className={cn(className, styles.btn, styles['applied-btn'])}
                >{t('web_common_you_have_applied')}</Button>
            </>

        )
    }

    // 活动中，可申请
    return (
        <>
            <HelpPopup
                ref={popupRef}
                drawerProps={{
                    height: 'auto',
                    closeIcon: <Iconfont className={cn(styles['close-icon'], 'icon-x')}/>,
                    closePlacement: 'left',
                }}
                footer={false}
                width={370}
                title={t('web_shop_activity_early_access_guidelines')}
                trigger={(
                    <Button
                        {...BtnProps}
                        className={cn(className, styles['btn'])}
                    >{t('web_common_apply')}</Button>
                )}
                contentSize={'large'}
                content={(
                    <div className={cn(styles['popup-warp'])}>
                        <p className={cn(styles.content)}>
                            {t('web_shop_activity_early_access_guidelines_desc1', {
                                points: product.points
                            })}
                        </p>

                        <Button
                            loading={loading}
                            block
                            className={styles['apply-btn']}
                            onClick={onSubmit}
                        >{t('web_common_apply')}</Button>
                    </div>
                )}
            />
        </>
    )

};

export default OptionsButton